//export const iwdPath = 'http://localhost:5000';
//export const iwdPath = 'https://ptr.isleward.com';
export const iwdPath = 'https://play.isleward.com';
